import {
  BaseQueryApi,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
  retry,
} from "@reduxjs/toolkit/query/react";
//import { RootState } from "..";
import { baseURL } from "../../api";
import Cookies from "js-cookie";
import { RootState } from "..";
import { setLastAPITriggerTime } from "../slices/commonSlice";
import { decodeToken } from "../../utils/decodeToken";

const baseQueryFetchFunction = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: any
) =>
  fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: async (headers, { getState }) => {
      const token: any = Cookies.get("accessToken") || "";
      if (token && api.endpoint !== "loginUser") {
        const { tokenExpiryPeriodInSeconds, tokenExpiryTime } =
          decodeToken(token);
        const expiry: number = tokenExpiryTime * 1000;
        const lastApiCallTime: any = (getState() as RootState)?.commonSlice
          ?.lastAPITriggerTime;
        if (expiry > new Date().getTime()) {
          headers.set("authorization", `Bearer ${token}`);
          return headers;
        } else if (
          new Date().getTime() - parseInt(lastApiCallTime) <
          tokenExpiryPeriodInSeconds * 1000
        ) {
          const reauthHeaders: any = {
            "Content-Type": "application/json",
            token: Cookies.get("refreshToken"),
          };
          const reauth = await fetch(`${baseURL}/auth/refresh_token`, {
            method: "post",
            headers: reauthHeaders,
          });
          const reauthResponse = await reauth.json();
          const access_token = reauthResponse["access_token"];
          const refresh_token = reauthResponse["refresh_token"];
          const { tokenExpiryPeriodInSeconds } = decodeToken(access_token);
          Cookies.set("accessToken", access_token, {
            expires: tokenExpiryPeriodInSeconds / (24 * 60 * 60),
          });
          Cookies.set("refreshToken", refresh_token, {
            expires: 15 / (24 * 60),
          });
          headers.set("authorization", `Bearer ${access_token}`);
          return headers;
        }
      }
      return headers;
    },
  })(args, api, extraOptions);

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = retry(
  async (args: string | FetchArgs, api, extraOptions) => {
    const result = await baseQueryFetchFunction(args, api, extraOptions);
    api.dispatch(setLastAPITriggerTime(new Date().getTime()));
    if (
      result?.error &&
      result?.error?.status == 401 &&
      api.endpoint !== "loginUser"
      // && !result?.meta?.request.headers.get("authorization")
    ) {
      const email = ((api.getState()) as RootState).commonSlice.userObj
      const headers:any = { 
        'Content-Type': 'application/json',
        'access-token': Cookies.get('accessToken') || '',
        'refresh-token':Cookies.get('refreshToken') || ''
     }
      const logoutCall = await fetch(`${baseURL}/auth/logout/${email}`,{
        method: 'post',
        headers,
      })
      const logoutResponse = await logoutCall.json()
      console.debug(logoutResponse)
      Cookies.remove("accessToken");
      Cookies.remove("refreshToken");
      console.debug("Session expired, login again");
      window.location.replace("/login");
    }
    return result;
  },
  {
    maxRetries: 1,
  }
);
